export default __webpack_public_path__ + "static/media/redgreen.e7b16ba9.png";